import {
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Text,
  useBreakpointValue,
  // useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { useRef } from "react";
import DrawerLoader from "../Loader/DrawerLoader";
import store from "../../../store/store";
import { drawerCloseIconColor, textColor } from "../../../globalColors";

interface CustomDrawerProps {
  open: boolean;
  title?: string;
  close: any;
  children: any;
  size?: string;
  props?: any;
  width?: any;
  loading?: boolean;
}

const CustomDrawer: React.FC<CustomDrawerProps> = ({
  title,
  open,
  close,
  size,
  children,
  width,
  loading = false,
  props,
}) => {
  const {
    themeStore: { themeConfig },
  } = store;
  const drawerRef = useRef<HTMLDivElement>(null);
  // const { colorMode } = useColorMode();
  const isDesktop = useBreakpointValue({ base: false, md: true });

  const headerBgColor = useColorModeValue(
    themeConfig.colors.custom.light.primary,
    themeConfig.colors.custom.dark.primary
  );
  // const headerTextColor = colorMode === "dark" ? "white" : "white";
  const handleCloseDrawer = () => {
    close();
  };

  return (
    <Drawer
      isOpen={open}
      placement="right"
      onClose={handleCloseDrawer}
      size={size ? size : "xl"}
      finalFocusRef={drawerRef}
      {...props}
    >
      <DrawerOverlay />
      <DrawerContent
        css={{
          width: width ? (isDesktop ? width : undefined) : undefined,
          maxWidth: width ? (isDesktop ? width : undefined) : undefined,
          transition: "transform 0.1s ease-out",
          padding: 0,
          transform: open ? "translateX(0)" : "translateX(100%)",
          ...props,
        }}
      >
        {title && (
          <Flex
            justify="space-between"
            alignItems="center"
            p={4}
            bg={headerBgColor}
            color={textColor}
          >
            <Text fontSize="xl">{title}</Text>
            <DrawerCloseButton
              color={drawerCloseIconColor}
              _hover={{ color: "#00000" }}
              size="lg"
              mt={1}
            />
          </Flex>
        )}
        <Divider />
        <DrawerBody
          style={{ overflowY: "auto", padding: "0px" }}
        >
          <DrawerLoader loading={loading}>
            <div style={{ width: "100%" }}>{children}</div>
          </DrawerLoader>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default CustomDrawer;
